module.exports = __webpack_public_path__ + "static/media/cover.461d0979.png";